'use client'

import { type ReactNode, useEffect, useRef } from 'react'
import { isPageScrolledStore } from '@/components/Law/Clause/scroll-store'
import * as styles from '@/app/[category]/[subCategory]/[norm]/law.css'
import { Clamp, Stack } from '@christiankaindl/lyts'
import Heading from '@shared/components/Heading/Heading'
import Breadcrumbs, {
  type BreadcrumbsProps,
} from '@/components/Breadcrumbs/Breadcrumbs'
import { observe } from 'react-intersection-observer'

interface HeaderProps {
  breadcrumbs: BreadcrumbsProps['crumbs']
  title: string | ReactNode
  subTitle?: ReactNode
  size?: 'large' | 'default'
}
export function Header({ breadcrumbs, title, subTitle, size }: HeaderProps) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (!element) {
      return
    }

    return observe(element, (inView) => {
      isPageScrolledStore.set(!inView)
    })
  }, [])

  return (
    <Clamp clamp='1150px' asChild yAlign='start'>
      <header className={styles.header}>
        <Stack gap={1}>
          <Breadcrumbs crumbs={breadcrumbs} />
          {title && typeof title === 'string' && (
            <Stack
              ref={ref}
              style={{ marginTop: '1.25em', marginBottom: '1.75em' }}
            >
              <Heading
                h={1}
                style={{ fontStyle: 'normal', fontWeight: 600 }}
                className={size === 'large' ? styles.largeHeader : undefined}
              >
                {title}
              </Heading>

              {subTitle}
            </Stack>
          )}
          {title && typeof title !== 'string' && (
            <Stack ref={ref}>
              {title}
              {subTitle}
            </Stack>
          )}
        </Stack>
      </header>
    </Clamp>
  )
}
